import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Image from "gatsby-image"
import styled from "styled-components"
import { device } from "../../utils/breakpoints"

const Img = styled(Image)`
  position: absolute !important;
  bottom: 0;
  left: -20%;
  width: 90%;
  opacity: .3;
  @media ${device.md} {
    left: 0;
    bottom: 0;
    width: 70%;
    opacity: .95;
  }
`

function AmateursImage() {
  const { image } = useStaticQuery(graphql`
    query {
      image: file(relativePath: { eq: "amateurs-image.png" }) {
        sharp: childImageSharp {
          fluid(quality: 80, maxWidth: 1920) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)
  return <Img fluid={image.sharp.fluid} />
}

export default AmateursImage
